<template>
  <div class="landing-main-div min-h-screen w-full">
    <nav
      class="flex items-center justify-between px-6 py-4 text-white bg-black"
    >
      <div class="text-green-400 text-2xl font-bold">Snappy</div>
      <div class="hidden md:flex space-x-6 text-gray-300">
        <!--        <a href="#" class="hover:text-white">Bosh sahifa</a>-->
      </div>

      <div class="flex items-center space-x-4">
        <button
          class="p-2 rounded-[15px] bg-gray-700"
          @click="goLogin"
          v-if="!token"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.534 10.208H2.5M10.094 7.778l2.44 2.43-2.44 2.43"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M6.444 6.348V5.57a3.07 3.07 0 013.07-3.07h4.07a3.062 3.062 0 013.063 3.063v9.283a3.071 3.071 0 01-3.07 3.07H9.506a3.063 3.063 0 01-3.062-3.062v-.785"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
        <div v-if="token" class="relative" ref="dropdownContainer">
          <button
            @click.stop="toggleDropdown"
            class="flex items-center justify-center bg-gray-800 rounded-lg w-10 h-10 text-white focus:outline-none"
          >
            <i class="fas fa-user"></i>
          </button>
          <div
            v-if="isOpen"
            class="absolute right-0 mt-2 w-56 bg-gray-800 rounded shadow-lg z-50"
          >
            <div class="p-3 flex items-center border-b border-gray-700">
              <div
                class="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white mr-3"
              >
                <i class="fas fa-user"></i>
              </div>
              <div>
                <div class="text-white font-medium">{{ userInfo.name }}</div>
                <div class="text-gray-400 text-sm">{{ userInfo.phone }}</div>
              </div>
            </div>
            <div class="py-1 border-t border-gray-700">
              <a
                v-for="(item, index) in menuItems"
                :key="index"
                :href="item.link"
                class="px-4 py-2 flex items-center text-white hover:bg-gray-700 cursor-pointer"
              >
                <i :class="[item.icon, 'w-6 text-gray-400']"></i>
                <span class="ml-2">{{ item.text }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      menuItems: [
        {
          text: "Akkauntni boshqarish",
          icon: "fa-solid fa-gear",
          link: "/account",
        },
        { text: "Admin panel", icon: "fas fa-user", link: "/admin" },
        { text: "Chiqish", icon: "v", link: "/" },
      ],
      userInfo: {
        name: "Oxunjon Usmonov",
        phone: "+998910586773",
      },
      token: null,
    };
  },
  mounted() {
    this.checkToken();
    document.addEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown(event) {
      event.stopPropagation(); // Hodisa tashqariga chiqmasin
      this.isOpen = !this.isOpen; // Dropdown ochiq bo‘lsa yopadi, yopiq bo‘lsa ochadi
    },
    handleClickOutside(event) {
      const dropdownContainer = this.$refs.dropdownContainer;
      if (dropdownContainer && !dropdownContainer.contains(event.target)) {
        this.isOpen = false;
      }
    },
    checkToken() {
      this.token = localStorage.getItem("accessToken");
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.landing-main-div {
  background-image: url("../assets/image/login_page_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
